import { ColumnsType } from "antd/es/table";
import { Space, Dropdown, Tooltip, Tag } from "antd";
import { BotoesAcoes } from "../../ViewGerenciarPostagens/styles"; // Botões de ação
import SettingsIcon from "@mui/icons-material/Settings";
import { getMenuItems } from "../constants/itemsActionColumns";
import ColumnSearch from "../../../components/ColumnSearch";
import { formatPhoneNumber } from "../../../uteis/formatPhoneNumber";

export const Columns = (
  onClick: (e: any) => void,
  setIndicacaoId: (e: number) => void,
  setIndicacaoStatus: (e: string) => void,
  filteredInfo: {
    nomeParceiro?: string[] | null;
    nomeLeads?: string[] | null;
    celular?: string[] | null;
    status?: string[] | null;
  }
): ColumnsType<any> => {
  const items = getMenuItems();

  return [
    {
      title: "Nome Parceiro",
      dataIndex: "nomeParceiro",
      key: "nomeParceiro",
      width: "30%",
      render: (_, row) => (
        <Tooltip title={row.descricao}>
          <Tag>{row.nomeParceiro}</Tag>
        </Tooltip>
      ),
      filteredValue: filteredInfo.nomeParceiro || null, // Aplicar os valores do estado
      onFilter: (value, record) => record.nomeParceiro.includes(value),
      ...ColumnSearch<any>({ dataIndex: "nomeParceiro" }),
    },
    {
      title: "Lead",
      dataIndex: "nomeLeads",
      key: "nomeLeads",
      width: "30%",
      filteredValue: filteredInfo.nomeLeads || null, // Aplicar os valores do estado
      onFilter: (value, record) => record.nomeLeads.includes(value),
      ...ColumnSearch<any>({ dataIndex: "nomeLeads" }),
    },
    {
      title: "Telefone",
      dataIndex: "celular",
      key: "celular",
      width: "30%",

      filteredValue: filteredInfo.celular || null, // Aplicar os valores do estado
      onFilter: (value, record) => record.celular.includes(value),
      ...ColumnSearch<any>({ dataIndex: "celular" }),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: "30%",
      filters: [
        { text: "Verificar", value: "VERIFICAR" },
        { text: "Desistiu", value: "DESISTIU" },
        { text: "Pendente Pagamento", value: "PENDENTE_PAGAMENTO" },
        { text: "Pago", value: "PAGO" },
      ],
      filteredValue: filteredInfo.status || null,
      onFilter: (value, record) => record.status.includes(value),
      filterSearch: true,
      render: (text: string) => {
        if (!text) return text;
        // substitui '_' por espaço e capitaliza cada palavra
        return text
          .toLowerCase()
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
      },
    },
    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      width: "10%",
      align: "center",
      filteredValue: null,
      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                setIndicacaoId(row.id);
                setIndicacaoStatus(row.status);
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];
};
